import { map } from 'lodash'
import React from 'react'
import styled from 'styled-components'

export interface ICrumb {
	name: string
	url: string
}
export interface IBreadCrumbs {
	crumbs: ICrumb[]
}

function BreadCrumbs({ crumbs }: IBreadCrumbs) {
	return (
		<Crumbs>
			{map(crumbs, (crumb, index: number) => (
				<>
					<Crumb href={crumb.url}>{crumb.name}</Crumb>
					{index < crumbs.length - 1 && <span> / </span>}
				</>
			))}
		</Crumbs>
	)
}

export default BreadCrumbs

const Crumbs = styled.span`
	font-family: var(--font-atyp-display);
	font-size: 1.5rem;
	line-height: 150%;
	font-weight: 300;
`
const Crumb = styled.a`
	&:hover {
		text-decoration: underline;
	}
`
